export const profile = {
  profileFavoritesIconTitle: 'Ulubione',
  profileEditIconTitle: 'Edytuj',
  profileShareIconTitle: 'Udostępnij',
  profileAdditionalSectionTitle: 'Dodatkowe informacje',
  profileFavoritesCurtainTitle: 'Ulubione',
  profileFavoriteActionTitle: 'Dodaj do ulubionych',
  profileFavoritedActionTitle: 'Dodano do ulubionych',
  profileMessageAction: 'Wiadomość',
  profileCurtainAdd: 'Dodaj',
  profileReportUser: 'Zgłoś użytkownika',
  profileReportTitle: 'Zgłoś',
  profileReportSuccess: 'Treść zgłoszona',
  profileReset: 'Zresetuj',
  profileApply: 'Zastosuj',
  profileCustomInvalidEmail: 'nie jest prawidłowym adresem e-mail',
  profileMaxContentSizeError: 'Przekroczyłeś maksymalny rozmiar treści!',
  profileMaxAvatarSizeError: 'Twój awatar jest zbyt duży!',
  profileFavoritesCurtainSearchInputText: 'Szukaj',
  profileTapShareCurtainOptionTitle: 'Kopiuj link',
  profileTapShareLinkCopiedAlertTitle: 'Link skopiowany!',
  profileQrShareCurtainTitle: 'Udostępnij profil',
  profileQrShareCurtainShareButtonTitle: 'Udostępnij',
  profileQrShareCurtainCopyButtonTitle: 'Kopiuj link',
  profileQrShareCurtainCopiedAlertTitle: 'Link skopiowany!',
  profileQrTapShareProfileCurtainTitle: 'Udostępnij swój profil',
  profileEditTitle: 'Edytuj',
  profileEditPersonalSectionTitle: 'Dane osobowe',
  profileEditContactsSectionTitle: 'Kontakty',
  profileEditSocialSectionTitle: 'Social media',
  profileEditAddSocialButtonTitle: 'Dodaj media społecznościowe',
  profileEditAdditionalSectionTitle: 'Dodatkowe informacje',
  profileEditSaveButtonTitle: 'Zapisz',
  profileEditSavedAlertTitle: 'Profil zapisany!',
  profileEditEmptyRequiredInputTitle: 'Wartość nie może być pusta',
  profileEditEmptyRequiredEmailInputTitle: 'Publiczny adres e-mail jest nieprawidłowy',
  profileEditEmptyRequiredErrorTitle: 'Coś poszło nie tak!',
  profileEditSocialsHint: 'Proszę wprowadzić URL do swojego profilu społecznościowego',
  preferences: 'Preferencje',
  interestedIn: 'Zainteresowany',
  expertIn: 'Jestem ekspertem w',
  myPitch: 'Moja prezentacja',
  qrBadge: 'QR Badge',
  touchpoints: 'Touchpoints',
  lookingFor: 'Szukam',
  topicsToDiscuss: 'Tematy do omówienia',
  createNew: 'Utwórz nowe',
  viewTopic: 'Zobacz temat',
  hobbyInterests: 'Hobby i zainteresowania',
  myNetwork: 'Moja sieć',
  seeAll: 'Zobacz wszystkie',
  checkThemOut: 'Zobacz!',
  activities: 'Aktywności',
  oneOnOne: 'Spotkanie 1:1',
  Leaderboard: 'Tabela wyników',
  learnNetworking: 'Dowiedz się więcej o Networking Hub',
  networkingGroup: 'Grupa networkingowa',
  networkingLevel: 'Poziom networkingu',
  addNote: 'Dodaj notatkę',
  notes: 'Notatki',
  enterNote: 'Wprowadź notatkę',
  shareUserProfile: 'Udostępnij profil użytkownika',
  flagUser: 'Zgłoś użytkownika'
}
